// Qué mostrarle al usuario cuando una llamada del panel "Corregir voz" no sale OK.
//
// El backend ya manda copy apto para la UI: sus rutas pasan el error por
// `userFacingMessage` y lo devuelven junto con un `error_type`. El problema es que
// `pedirYEsperar` reenviaba `json.error` SIEMPRE, y cuando el que contesta es Fastify —la
// ruta no existe, el body no parsea, el proceso está caído— ese campo no es copy nuestro
// sino la etiqueta HTTP en inglés. El 2026-09-23 una usuaria leyó literalmente
// "Not Found" porque el backend de la feature no estaba deployado
// (ADR-2026-09-23-corregir-voz-quedo-sin-backend-en-produccion).
//
// El discriminador es `error_type`: lo ponen TODAS las respuestas de error que escriben
// nuestras rutas y ninguna de las que arma Fastify solo. Mismo criterio que
// `mensajeDeUpscaleFallido` en `lib/imageEdit.ts`.

const GENERICO = "Tuvimos un problema técnico. Intentá de nuevo en un momento.";

/** Copy propio para los estados que contesta la infraestructura, no nuestras rutas. */
const POR_STATUS: Record<number, string> = {
  // La ruta no existe en el backend que está corriendo: típicamente el front salió y el
  // backend que lo atiende todavía no. No es culpa de lo que el usuario pidió.
  404: "Esta función todavía no está disponible. Probá de nuevo más tarde.",
  401: "Tu sesión expiró. Volvé a iniciar sesión y probá otra vez.",
  403: "Tu sesión expiró. Volvé a iniciar sesión y probá otra vez.",
  413: "El video es demasiado grande para corregirlo.",
  429: "Hay muchos pedidos en curso. Esperá unos minutos y probá de nuevo.",
};

/**
 * `status` es el HTTP de la respuesta y `json` su cuerpo ya parseado (puede venir vacío
 * si no era JSON). Pura a propósito: se testea sin tocar la red.
 *
 * ⚠️ Se exige `error` y NO se lee `message`, aunque algunas respuestas traigan las dos
 * cosas. El guard de auth contesta `{error_type: "auth", message: "falta el token
 * (Authorization: Bearer <jwt de Supabase>)"}` —verificado contra producción el
 * 2026-09-23— y ese texto es para quien programa, no para quien usa la app. Las rutas
 * ponen el copy en `error`; el middleware pone detalle técnico en `message`. Leer
 * `message` "para aprovecharlo" volvería a poner una cadena de desarrollador en pantalla,
 * que es exactamente el bug que esto viene a cerrar.
 */
export function mensajeDeErrorDelBackend(status: number, json: Record<string, unknown>): string {
  // Sólo se confía en `json.error` cuando lo escribió una ruta nuestra, y sólo si es
  // texto de verdad.
  if (typeof json.error_type === "string" && typeof json.error === "string" && json.error.trim()) {
    return json.error;
  }
  return POR_STATUS[status] ?? GENERICO;
}
